import { ReactComponent as RemoveIcon } from "assets/images/icons/icn_table_cell_Unverified.svg";

import React, { useEffect, useState } from 'react';
import { TableRow, TableCell, TextField } from '@mui/material';
import MacAddressInputField from "components/InputField/MacAddressInputField";

const MacAddressTableRow = ({
  originalMacAddresses,
  mac,
  form,
  index,
  disabled = false,
  onMacAddressChange,
  onSnInformationChange,
  onDeleteMacAddress,
  onPasteMacAddress
}) => {
  const [error, setError] = useState(false);

  const checkDuplicateMac = (macAddress) => {
    const upperMac = macAddress.toUpperCase();
    const duplicate = originalMacAddresses.filter((item) => item.macAddress.toUpperCase() === upperMac);
    return duplicate.length > 1;
  }

  useEffect(() => {
    const v = mac.macAddress.toUpperCase();
    setError(mac.macAddressDirty && (!form.validateMacAddress(v) || checkDuplicateMac(v)));
  }, [mac.macAddress, form]);

  return (
    <TableRow>
      <TableCell sx={{ width: "400px" }}>
        <MacAddressInputField
          value={mac.macAddress}
          onChange={(newVal) => {
            onMacAddressChange(index, "macAddress", newVal);
            const v = newVal.toUpperCase();
            setError(mac.macAddressDirty && (!form.validateMacAddress(v) || checkDuplicateMac(v)));
          }}
          disabled={disabled}
          showError={error}
          onPaste={(e) => onPasteMacAddress && onPasteMacAddress(e, index)}
        />
      </TableCell>
      <TableCell sx={{ width: "400px" }}>
        <TextField
          value={mac.snInformation}
          sx={{ ...form.getTextfieldStyle(true) }}
          fullWidth
          disabled={disabled}
          onChange={(e) => onSnInformationChange(index, "snInformation", e.target.value)}
        />
      </TableCell>
      <TableCell sx={{ width: "100px" }}>
        {index !== 0 && (
          <>
            <RemoveIcon onClick={() => onDeleteMacAddress(index)} style={{ cursor: 'pointer' }} />
          </>
        )}
      </TableCell>
    </TableRow>
  );
}

export default React.memo(MacAddressTableRow);
